
    const data = {"name":"src/core/icons/checkbox-marked-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 19H5V5h10V3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8h-2m-11.09-.92L6.5 11.5 11 16 21 6l-1.41-1.42L11 13.17l-3.09-3.09Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            